export default __webpack_public_path__ + "static/media/collection.2c4ec066.svg";